import { Component, EventEmitter, OnInit } from '@angular/core';
import { injectTemplateRef } from '@angular/core/src/render3/view_engine_compatibility';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexPlotOptions, ApexXAxis } from 'ng-apexcharts';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { SalesPersonService } from 'src/app/services/crew-services/sales-person.service';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { ClientTaskService } from 'src/app/services/task/client-task.service';
import DateUtils from 'src/app/utils/date';

export type ApexChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  colors: string[]
};

@Component({
  selector: 'app-task-report',
  templateUrl: './task-report.component.html',
  styleUrls: ['./task-report.component.css']
})

export class TaskReportComponent implements OnInit {
  showOption = false;
  dataChanged: Observable<any>;
  filteredSource: EventEmitter<any> = new EventEmitter<any>(null);
  dateUtil = new DateUtils;
  monthsList;
  spList = [];
  startYr;
  endYr;
  dealsData;
  yearList: any[];
  dataTableTask = {
    dataChangedObs: new BehaviorSubject(null),
    heads: [
      { title: "Month", key: "month" },
      { title: "Pending", key: "pending" },
      { title: "Completed", key: "completed" },
      { title: "Due", key: "due" },
      { title: "Voided", key: "voided" },
    ],
    rows: [],
    options: {
      datePipe: {},
      singleActions: [],
      bulkActions: [],
      noOfRowsToDisplay: 5
    },
  };
  ViewSwitch = "Chart";
  public chartOptions = {
    series: [
      {
        name: "pending",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        name: "completed",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        name: "due",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        name: "voided",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

      }
    ],
    chart: {
      type: "bar",
      height: 270
    },
    legend: {
      position: 'right',
      offsetY: 40
    },
    plotOptions: {
      bar: {
        horizontal: false,
        // distributed: true,
        // columnWidth: '60%',
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      title: {
        text: 'Months',
      },
    },
    yaxis: {
      title: {
        text: 'Counts',
      },
      labels: {
        formatter: function (value) {
          return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value)
        }
      },
    },
    colors: ['#ffbb33', '#00c851', '#0866C6', '#DC3545'],
  };
  barChartYear = new Date().getFullYear();;
  quarters = {
    pending: { 0: 0, 1: 0, 2: 0, 3: 0 },
    completed: { 0: 0, 1: 0, 2: 0, 3: 0 },
    due: { 0: 0, 1: 0, 2: 0, 3: 0 },
    voided: { 0: 0, 1: 0, 2: 0, 3: 0 },
  };
  newArray = {
    pending: {
      count: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 },
    },
    completed: {
      count: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 },
    },
    due: {
      count: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 },
    },
    voided: {
      count: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 },
    },
  };
  filterBy = '';
  payload = {
    quarterly: [],
    monthly: []
  }
  ngFilters = {
    salesPersonIds: [],
    teamIds: [],
  }
  store = {
    salesPerson: {
      list: [],
      selected: []
    }
  }
  filter = {
    salesPersonTeam: '',
    year: new Date().getFullYear(),
    period: 'monthly',
  }
  defaultMonth = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 };
  defaultQuarter = { 0: 0, 1: 0, 2: 0, 3: 0 };
  multiSalesTeams;
  mutipleSalespTeamsTableData;
  selectedNames;

  constructor(
    private taskSvc: ClientTaskService,
    private performanceSvc: PerformanceReportService,
  ) {
    this.yearList = this.dateUtil.getYears();
  }

  ngOnInit() {
    this.onChangeFilters();
  }

  onChangeFilters() {
    this.showOption = false;
    this.mutipleSalespTeamsTableData = null;
    this.processSalesPersonTeamFilters();
  }

  processSalesPersonTeamFilters() {
    // Get Select SalesPerson and Team Ids
    this.performanceSvc.selected_users.subscribe((res) => {
      if (res.ids.length > 0) {
        const { ids, type, names } = res;
        this.selectedNames = names;
        if (type === 'salesperson') {
          this.ngFilters.salesPersonIds = ids;
          this.ngFilters.teamIds = [];
        } else if (type === 'team') {
          this.ngFilters.teamIds = ids;
          this.ngFilters.salesPersonIds = [];
        }
      }
      const year = this.filter.year || new Date().getFullYear();
      this.getTaskListByYear(year);
    });
  }

  getTaskListByYear(year) {
    try {
      const from = Date.parse(new Date(`01/01/${year}`).toISOString());
      const to = Date.parse(new Date(`12/31/${year}`).toISOString());

      // body
      const body = {
        type: 2,
        createdDateTo: to,
        createdDateFrom: from,
        teamID: [...this.ngFilters.teamIds],
        userID: [...this.ngFilters.salesPersonIds],
      };

      this.taskSvc.fetchTaskList(body).subscribe(payload => {
        this.filteredSource.emit({ action: "payload", data: payload });
      });
    } catch (error) {

    } finally {
      this.formulateMultiSalesTeam();
      this.onEmitSourceData();
      this.dataTableTask.dataChangedObs.next(true);
    }
    this.showOption = true;
  }

  onEmitSourceData() {
    this.filteredSource.subscribe((res) => {
      let result;

      if (res.data) {

        // Check period status
        // filter by period status
        const period = this.filter.period;

        switch (period) {
          case 'monthly':
            result = this.processMonthlyData(res.data);
            break;

          case 'quarterly':
            result = this.processQuarterlyData(res.data);
            break;

          default:
            break;
        }
      }
      this.dataTableTask.rows = result;
    });
  }

  processMonthlyData(payload) {
    // Reset
    this.newArray.pending.count = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 }
    this.newArray.completed.count = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 }
    this.newArray.due.count = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 }
    this.newArray.voided.count = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 }

    payload.forEach(data => {
      const date = data.createdDate.split(" ")[0];
      const dateParts = date.split("/");
      const dateString = `${dateParts[1]}/${dateParts[0]}/${dateParts[2]}`;
      const month = new Date(dateString).getMonth();
      this.processTaskData(data, month);
    });

    const tableData = [];
    const getMonth = this.chartOptions.xaxis.categories;

    for (let i = 0; i < 12; i++) {
      tableData.push({
        month: getMonth[i],
        pending: this.newArray.pending.count[i],
        completed: this.newArray.completed.count[i],
        due: this.newArray.due.count[i],
        voided: this.newArray.voided.count[i],
      });
    }

    // Reconfigure chartOptions for Monthly
    this.chartOptions = {
      ...this.chartOptions,
      series: [
        {
          name: "pending",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: "completed",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: "due",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: "voided",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ],
      xaxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
        title: {
          text: 'Months',
        },
      },
    };

    // Set Chart Data
    this.chartOptions.series[0].data = Object.values(this.newArray.pending.count);
    this.chartOptions.series[1].data = Object.values(this.newArray.completed.count);
    this.chartOptions.series[2].data = Object.values(this.newArray.due.count);
    this.chartOptions.series[3].data = Object.values(this.newArray.voided.count);

    // this.dataTableTask.rows = tableData;
    // this.payload.monthly = tableData;
    return tableData;
  }

  processQuarterlyData(arr) {
    // Reset
    this.quarters.pending = { 0: 0, 1: 0, 2: 0, 3: 0 };
    this.quarters.due = { 0: 0, 1: 0, 2: 0, 3: 0 };
    this.quarters.pending = { 0: 0, 1: 0, 2: 0, 3: 0 };
    this.quarters.voided = { 0: 0, 1: 0, 2: 0, 3: 0 };

    let result = this.processMonthlyData(arr);

    // Format Data
    const format = {
      month: '',
      due: 0,
      voided: 0,
      pending: 0,
      completed: 0,
    };
    let payload = [{ ...format }, { ...format }, { ...format }, { ...format }];

    if (result.length > 0) {
      result.forEach(month => {
        let index = 0;
        let quarterName = 'Q1';
        if (!(month && month.month)) return;
        switch ((month.month).toLowerCase()) {
          case 'jan':
          case 'feb':
          case 'mar':
            index = 0;
            quarterName = 'Q1';
            break;
          case 'apr':
          case 'may':
          case 'june':
            index = 1;
            quarterName = 'Q2';
            break;
          case 'jul':
          case 'aug':
          case 'sep':
            index = 2;
            quarterName = 'Q3';
            break;
          case 'oct':
          case 'nov':
          case 'dec':
            index = 3;
            quarterName = 'Q4';
            break;
          default:
            break;
        }
        payload[index].month = quarterName;
        payload[index].pending += month.pending;
        payload[index].completed += month.completed;
        payload[index].due += month.due;
        payload[index].voided += month.voided;

        this.quarters.due[index] = payload[index].due;
        this.quarters.voided[index] = payload[index].voided;
        this.quarters.pending[index] = payload[index].pending;
        this.quarters.completed[index] = payload[index].completed;
      });
    }

    // Reconfigure chartOptions for Quaterly
    this.chartOptions = {
      ...this.chartOptions,
      series: [
        {
          name: "pending",
          data: [0, 0, 0, 0]
        },
        {
          name: "completed",
          data: [0, 0, 0, 0]
        },
        {
          name: "due",
          data: [0, 0, 0, 0]
        },
        {
          name: "voided",
          data: [0, 0, 0, 0]
        }
      ],
      xaxis: {
        categories: ['Q1', 'Q2', 'Q3', 'Q4'],
        title: {
          text: 'Quarters',
        },
      },
    };

    // Set Chart Data
    this.chartOptions.series[0].data = Object.values(this.quarters.pending);
    this.chartOptions.series[1].data = Object.values(this.quarters.completed);
    this.chartOptions.series[2].data = Object.values(this.quarters.due);
    this.chartOptions.series[3].data = Object.values(this.quarters.voided);
    return payload;
  }

  private processTaskData(data, month: number) {
    if (data.status === "PENDING") {
      this.newArray.pending.count[month]++;
    }
    else if (data.status === "COMPLETED") {
      this.newArray.completed.count[month]++;
    }
    else if (data.status === "OVERDUE") {
      this.newArray.due.count[month]++;
    }
    else if (data.status === "VOIDED") {
      this.newArray.voided.count[month]++;
    }
  }

  handleViewSwitch(view) {
    this.ViewSwitch = view;
  }

  private transDateToMonth(dateVal: string) {
    const date = dateVal.split(" ")[0];
    const dateParts = date.split("/");
    const dateString = `${dateParts[1]}/${dateParts[0]}/${dateParts[2]}`;
    const month = new Date(dateString).getMonth();
    return month;
  }

  generateDefSalesTeamData() {
    const result = {}
    Object.keys(this.selectedNames).forEach(id => {
      result[id] = {
        pending: { ...this.defaultMonth },
        completed: { ...this.defaultMonth },
        due: { ...this.defaultMonth },
        voided: { ...this.defaultMonth }
      }
    });
    this.multiSalesTeams = result;
  }

  formulateMultiSalesTeam() {
    this.mutipleSalespTeamsTableData = null;
    this.filteredSource.subscribe(({ action, data }) => {
      const finalResult = [];
      if (action === 'payload' && data) {
        if (this.selectedNames) {
          if (this.filter.period === 'monthly') {
            this.monthsList = this.dateUtil.monthList;
            this.generateDefSalesTeamData();
            data.forEach(dat => {
              const assigneeID = Number(dat.assigneeID);
              // const sKey = this.selectedType === 'salesperson' ? 'creatorID' : 'teamID';
              const month = this.transDateToMonth(dat.createdDate);
              let status: string = dat.status === 'OVERDUE' ? 'due' : dat.status;
              status = status.toLowerCase();
              this.incrementTaskCount({ assigneeID, status, month })
            });
            Object.keys(this.multiSalesTeams).forEach(id => {
              const data = this.multiSalesTeams[id];
              finalResult.push({ name: this.selectedNames[id].name, ...data });
            })
            this.mutipleSalespTeamsTableData = finalResult;
          }
          else if (this.filter.period === 'quarterly') {
            const quaterMmultiSalesPTeams = [];
            const quaters = ['Q1', 'Q2', 'Q3', 'Q4']
            this.monthsList = quaters;

            Object.keys(this.multiSalesTeams).forEach(id => {
              const data = this.multiSalesTeams[id];
              const pending = this.dateUtil.getQuarterlyData(data.pending).quartersObj;
              const completed = this.dateUtil.getQuarterlyData(data.completed).quartersObj;
              const due = this.dateUtil.getQuarterlyData(data.due).quartersObj;
              const voided = this.dateUtil.getQuarterlyData(data.voided).quartersObj;
              quaterMmultiSalesPTeams.push({ name: this.selectedNames[id].name, pending, completed, due, voided })
            });
            this.mutipleSalespTeamsTableData = quaterMmultiSalesPTeams
          }
        }
        this.dataTableTask.dataChangedObs.next(true);
      }
    })
  }

  incrementTaskCount({ assigneeID, status, month }) {
    let count = this.multiSalesTeams[assigneeID][status][month];
    if (count || count === 0) {
      count = count + 1;
    }
    this.multiSalesTeams[assigneeID][status][month] = count;
  }
}
